import { FormErrorMessage } from "@chakra-ui/react"
import { FormattedMessage } from "react-intl"
import { RequiredErrorMessage } from "../RequiredErrorMessage"

type Props = {
  fieldError?: { type?: string; message?: string }
}

export default ({ fieldError }: Props) => (
  <FormErrorMessage>
    {fieldError &&
      (fieldError.type === "required" ? (
        <RequiredErrorMessage />
      ) : (
        <FormattedMessage id={fieldError.message} />
      ))}
  </FormErrorMessage>
)
